<template>
    <div id="customer_credit" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="customerHeader" v-if="$route.params.flag == 'update' || customerUpdateflag==true">Update Customer Credit Information</span>
                    <span class="page-title" id="customerHeader" v-else>Add Customer Credit Information</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackCustomerList" >
                        <i class="fp-back"></i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content customer-credit-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="CustomerForm">
                                <div class="form-row row-cols-md-1 row-cols-1">
                                    <div class="col form-group">
                                        <div class="custom-checkbox">
                                            <div class="form-check form-check-inline">
                                                <label class="checkbox-custom"> Parts and Service
                                                    <input type="checkbox" checked="checked" name="checkbox" v-model="parts">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <label class="checkbox-custom"> Rental
                                                    <input type="checkbox" name="checkbox" v-model="rental">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <label class="checkbox-custom"> Lease
                                                    <input type="checkbox" name="checkbox" v-model="lease">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="field-error">{{applicationForError}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="list-sections"> <!--top user section-->
                                    <h5 class="section-title"> Filled By The User </h5>
                                    <div class="form-row row-cols-md-4 row-cols-1">
                                        <div class="col form-group" v-if="customerflag==true">
                                            <label class="control-label require">Customer:</label>
                                            <v-select v-model="custmer_id_val" name="checkUser"
                                                        label="text" :filterable="false" :options="customerArr"
                                                        @search="onSearch"
                                                        placeholder="Select Customer">
                                                <template slot="no-options">
                                                    Search Customers...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="field-error">{{customerError}}</div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label" for="code">Credit Contact:</label>
                                            <input type="text" class="form-control" v-model="contact" id="contact" placeholder="Enter credit contact" name="contact">
                                            <div class="field-error">{{contacterrors}}</div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label require" for="name">Phone:</label>
                                            <input type="text" class="form-control" v-cleave="{delimiter: '-',blocks: [3, 3, 4]}" v-model="phone" id="phone" placeholder="999-999-9999" name="phone">
                                            <!-- <input-mask id="phone" :alwaysShowMask="true" name="phone" v-model="phone" mask="999-999-9999" class="form-control" type="tel"></input-mask> -->
                                            <div class="field-error">{{phoneerror}}</div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label require" for="name">DOT Number:</label>
                                            <input type="text" class="form-control" v-model="dot" id="contact" placeholder="Enter DOT Number" name="dot">
                                            <div class="field-error">{{doterror}}</div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label" for="account"> Account Opened: </label>
                                            <div class="input-group">
                                                <date-picker placeholder="MM/DD/YYYY" id="account_opened" name="account_opened" :config="options" v-model="account_opened"></date-picker>
                                                <label for="account_opened" class="fp-calendar input-calender-icon"></label>
                                            </div>
                                            <div class="field-error"></div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label" for="credit-recieve"> Credit Reviewed: </label>
                                            <div class="input-group">
                                                <date-picker placeholder="MM/DD/YYYY" id="credit_recieved" name="credit_recieved" :config="options" v-model="credit_recieved"></date-picker>
                                                <label for="credit_recieved" class="fp-calendar input-calender-icon"></label>
                                            </div>
                                        </div>
                                        <!-- <div class="col form-group">
                                            <label class="control-label">Phoneable:</label>
                                            <div class="custome-radiobtn">
                                                <div class="form-check form-check-inline">
                                                    <label class="boolean optional radio-custom" for="phoneable">Yes
                                                        <input type="radio" v-model="phoneable" :value="'yes'" id="phoneable" name="phoneable">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <label class="boolean optional radio-custom" for="phoneable1"> No
                                                        <input type="radio" v-model="phoneable" :value="'no'" id="phoneable1" name="phoneable">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="field-error"></div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label">Rentable:</label>
                                            <div class="custome-radiobtn">
                                                <div class="form-check form-check-inline">
                                                    <label class="boolean optional radio-custom" for="rentable">Yes
                                                        <input type="radio" v-model="rentable" :value="'yes'" id="rentable" name="rentable">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <label class="boolean optional radio-custom" for="rentable1"> No
                                                        <input type="radio" v-model="rentable" :value="'no'" id="rentable1" name="rentable">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label">Mailable:</label>
                                            <div class="custome-radiobtn">
                                                <div class="form-check form-check-inline">
                                                    <label class="boolean optional radio-custom" for="mailable">Yes
                                                        <input type="radio" v-model="mailable" :value="'yes'" id="mailable" name="mailable">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <label class="boolean optional radio-custom" for="mailable1"> No
                                                        <input type="radio" v-model="mailable" :value="'no'" id="mailable1" name="mailable">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label">E-Mailable:</label>
                                            <div class="custome-radiobtn">
                                                <div class="form-check form-check-inline">
                                                    <label class="boolean optional radio-custom" for="emailable">Yes
                                                        <input type="radio" v-model="emailable" :value="'yes'" id="emailable" name="emailable">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <label class="boolean optional radio-custom" for="emailable1"> No
                                                        <input type="radio" v-model="emailable" :value="'no'" id="emailable1" name="emailable">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div> -->
                                        <!-- <div class="col form-group">
                                            <label class="control-label">D & B Rating:</label>
                                            <input type="text" id="d_b_rating" name="d_b_rating" class="form-control" placeholder="Enter Dun & Bradstreet Rating" v-model="d_b_rating">
                                        </div> -->
                                        <!-- <div class="col form-group">
                                            <label class="control-label">D & B Pay ID:</label>
                                            <input type="text" id="d_b_pay_idx" name="d_b_pay_idx" class="form-control" placeholder="Enter Dun & Bradstreet Pay Id" v-model="d_b_pay_idx">
                                        </div> -->
                                        <!-- <div class="col form-group">
                                            <label class="control-label">Rent For Phone:</label>
                                            <div class="custome-radiobtn">
                                                <div class="form-check form-check-inline">
                                                    <label class="boolean optional radio-custom" for="rent_for_phone">Yes
                                                        <input type="radio" v-model="rent_for_phone" :value="'yes'" id="rent_for_phone" name="rent_for_phone">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <label class="boolean optional radio-custom" for="rent_for_phone1"> No
                                                        <input type="radio" v-model="rent_for_phone" :value="'no'" id="rent_for_phone1" name="rent_for_phone">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label">Rent For Mail:</label>
                                            <div class="custome-radiobtn">
                                                <div class="form-check form-check-inline">
                                                    <label class="boolean optional radio-custom" for="rent_for_mail">Yes
                                                        <input type="radio" v-model="rent_for_mail" :value="'yes'" id="rent_for_mail" name="rent_for_mail">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <label class="boolean optional radio-custom" for="rent_for_mail1"> No
                                                        <input type="radio" v-model="rent_for_mail" :value="'no'" id="rent_for_mail1" name="rent_for_mail">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div> -->
                                        <div class="col form-group">
                                            <label class="control-label">Credit Limit:</label>
                                            <input type="text" id="credit_limit" name="credit_limit" class="form-control"
                                            placeholder="Enter Credit Limit" v-model="credit_limit"
                                            @keypress="isAmountCheck($event)"
                                            @blur="credit_limit = leaveFocus($event)"
                                            @focus="credit_limit = enterVal($event)">
                                        </div>
                                        <!-- <div class="col form-group">
                                            <label class="control-label">Rent For Email:</label>
                                            <div class="custome-radiobtn">
                                                <div class="form-check form-check-inline">
                                                    <label class="boolean optional radio-custom" for="rent_for_email">Yes
                                                        <input type="radio" v-model="rent_for_email" :value="'yes'" id="rent_for_email" name="rent_for_email">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <label class="boolean optional radio-custom" for="rent_for_email1"> No
                                                        <input type="radio" v-model="rent_for_email" :value="'no'" id="rent_for_email1" name="rent_for_email">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label">Discount Lost:</label>
                                            <div class="custome-radiobtn">
                                                <div class="form-check form-check-inline">
                                                    <label class="boolean optional radio-custom" for="discount_lost">Yes
                                                        <input type="radio" v-model="discount_lost" :value="'yes'" id="discount_lost" name="discount_lost">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <label class="boolean optional radio-custom" for="discount_lost1"> No
                                                        <input type="radio" v-model="discount_lost" :value="'no'" id="discount_lost1" name="discount_lost">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div> -->
                                        <!-- <div class="col form-group">
                                            <label class="control-label">Credit Limit BG:</label>
                                            <input type="text" id="credit_limit_bg" name="credit_limit_bg" class="form-control" placeholder="Enter Credit Limit" v-model="credit_limit_bg">
                                        </div> -->
                                        <!-- <div class="col form-group">
                                            <label class="control-label">Dunning Level:</label>
                                            <input type="text" id="dunning_level" name="dunning_level" class="form-control" placeholder="Enter Dunning Level" v-model="dunning_level">
                                        </div> -->
                                        <!-- <div class="col form-group">
                                            <label class="control-label">Restrictions:</label>
                                            <input type="text" id="restrictions" name="restrictions" class="form-control" placeholder="Enter Restriction" v-model="restrictions">
                                        </div> -->
                                        <div class="col form-group">
                                            <label class="control-label" for="address_2">Sic Code:</label>
                                            <v-select v-model="sicCode" class="custom-ci-auto-search" placeholder="Select Sic Code" label="text" id="SicCode" :options="sicCodesArr" name="SicCode">
                                            </v-select>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label" for="address_2">Priority Code:</label>
                                            <input type="text" id="priority_code" name="priority_code" class="form-control" placeholder="Enter Priority Code" v-model="priority_code">
                                        </div>
                                        <!-- <div class="col form-group">
                                            <label class="control-label" for="address_2">Customer Type:</label>
                                            <v-select v-model="customer_type" class="custom-ci-auto-search" placeholder="Select Customer Type" label="text" id="customer_type" :options="customerTypeArr" name="customer_type">
                                            </v-select>
                                        </div> -->
                                        <div class="col form-group">
                                            <label class="control-label">One Time Customer:</label>
                                            <div class="custome-radiobtn">
                                                <div class="form-check form-check-inline">
                                                    <label class="boolean optional radio-custom" for="one_time_cust">Yes
                                                        <input type="radio" v-model="one_time_cust" :value="'yes'" id="one_time_cust" name="one_time_cust">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <label class="boolean optional radio-custom" for="one_time_cust1"> No
                                                        <input type="radio" v-model="one_time_cust" :value="'no'" id="one_time_cust1" name="one_time_cust">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="col form-group">
                                            <label class="control-label" for="address_2">Reserve To SFX:</label>
                                            <input type="text" id="reserve_to_sfx" name="reserve_to_sfx" class="form-control" placeholder="Enter Reserve To SFX" v-model="reserve_to_sfx">
                                        </div> -->
                                        <!-- <div class="col form-group">
                                            <label class="control-label" for="credit_manager_id">Credit Manager:</label>
                                            <v-select v-model="credit_manager" name="credit_manager" placeholder="Select Credit Manager"
                                                        label="text"
                                                        :options="creditManagerArr">
                                            </v-select>
                                            <div class="field-error">{{ creditManagererrors }}</div>
                                        </div> -->
                                        <!-- <div class="col form-group">
                                            <label class="control-label" for="address_2">Last Key Code Use:</label>
                                            <input type="text" id="last_code_key_use" name="last_code_key_use" class="form-control" placeholder="Enter Key Code" v-model="last_code_key_use">
                                        </div> -->
                                        <!-- <div class="col form-group">
                                            <label class="control-label" for="address_2">Message Code:</label>
                                            <input type="text" id="message_code" name="message_code" class="form-control" placeholder="Enter Message Code" v-model="message_code">
                                        </div> -->
                                        <div class="col form-group">
                                            <label class="control-label">&nbsp;&nbsp;</label>
                                            <div class="custom-checkbox">
                                                <label for="tax_exempt" class="checkbox-custom">Tax Exempt
                                                <input type="checkbox" v-model="tax_exempt" id="tax_exempt" name="tax_exempt" v-on:click="taxEmeptSelect($event)">
                                                <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label">&nbsp;&nbsp;</label>
                                            <div class="custom-checkbox">
                                                <label for="pg_required" class="checkbox-custom">PG Required
                                                <input type="checkbox" v-model="pg_required" id="pg_required" name="pg_required" v-on:click="pgRequireSelect($event)">
                                                <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-row row-cols-md-2 row-cols-1">
                                        <div class="col form-group">
                                            <label :class="'control-label '+ docRequired">Verification Document:</label>
                                            <vue-dropzone
                                                id="vendorEstimateDropzone"
                                                :options="verificationDropzoneOptions"
                                                :destroyDropzone=false
                                                ref="dropzone"
                                                :headers="verificationDropzoneOptions.headers"
                                                @vdropzone-complete="afterComplete"
                                                @vdropzone-success="verificationstoreDocument"
                                                @vdropzone-removed-file="verificationremovedSelectedFile"
                                                >
                                            </vue-dropzone>
                                            <span class="field-error">{{docErrorVerification}}</span>
                                        </div>
                                    </div>
                                    <div class="form-row row-cols-md-2 row-cols-1">
                                        <div class="col form-group">
                                            <template  v-if="verificationdropZonePreviewFiles.length > 0">
                                                <label class="control-label" for="vendorEstimateDocs">Attachments:</label>
                                                <template  v-for="(uFile,fKey) in verificationdropZonePreviewFiles">
                                                    <div v-bind:key="'fileDiv'+fKey" class="attachment-list">
                                                        <i v-if="uFile.extension == 'pdf'" class="fp-pdf-icon"></i>
                                                        <i v-if="uFile.extension == 'doc' || uFile.extension == 'docs'" class="fp-text-document"></i>
                                                        <i v-if="uFile.extension == 'jpg' ||  uFile.extension == 'png' ||  uFile.extension == 'jpeg' " class="fp-image"></i>
                                                        <a title='View File' href="javascript:void(0)"  v-on:click="openDocument(uFile.url,uFile.extension)" v-bind:key="'fileName'+fKey" >
                                                            {{ uFile['display_name'] }}
                                                        </a>
                                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                                        <button type="button"  v-bind:key="'cancelBtn'+fKey" v-on:click="removeServerFile(uFile['file_name'],fKey,'verificationdoc');">
                                                            <i class="fp-close"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </template>
                                        </div>
                                    </div>
                            </div>
                            <hr class="light-hr"/>
                            <!-- Fields of Addign Credit Store of ansonia -->
                            <div class="list-sections">
                                <h5 class="section-title">Credit Score  </h5>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label" for="Risk Store"> Ansonia Risk Score: </label>
                                        <input type="text" class="form-control" iname="Risk Score" v-model="ansonia_risk_store" placeholder="Enter Risk Score">
                                        <div class="field-error">{{ansoniaRiskScoreError}}</div>
                                    </div>
                                    <!-- <div class="col form-group">
                                        <label class="control-label" for="DTP"> Ansonia DBT: </label>
                                        <input type="text" class="form-control" iname="Risk Store" v-model="ansonia_dtp" placeholder="Enter DBT">
                                        <div class="field-error">{{ansoniaDTPError}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="High Balance"> Ansonia High Balance: </label>
                                        <input type="text" class="form-control" iname="High Balance" v-model="ansonia_high_balance" placeholder="Enter High Balance">
                                        <div class="field-error">{{ansoniaHighBalanceError}}</div>
                                    </div> -->
                                    <div class="col form-group">
                                        <label class="control-label" for="Business Years"> Business Start Date : </label>
                                        <input type="text" class="form-control" iname="Business Year" v-model="years_in_business" placeholder="Enter Year" @keypress="isIntegerCheck($event)">
                                        <div class="field-error">{{yearsInBusinessError}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="DNB Paydex"> DNB Paydex Score : </label>
                                        <input type="text" class="form-control" iname="Business Year" v-model="dnb_paydex_score" placeholder="Enter Paydex Score">
                                        <div class="field-error">{{dnbPaydexError}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="Paynet Master"> Paynet Masterscore : </label>
                                        <input type="text" class="form-control" iname="Business Year" v-model="paynet_master_score" placeholder="Enter Master Score">
                                        <div class="field-error">{{paynetMasterError}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="Credit Grade"> Credit Grade : </label>
                                        <input type="text" class="form-control" iname="Business Year" v-model="credit_grade" placeholder="Enter Credit Grade">
                                        <div class="field-error">{{creditGradeError}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="Kin Score"> Full KIN Score : </label>
                                        <input type="text" class="form-control" iname="Business Year" v-model="full_kin_score" placeholder="Enter KIN Score">
                                        <div class="field-error">{{kinScoreError}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="Personal Credit Store"> Personal Credit Score: </label>
                                        <input type="text" class="form-control" iname="Personal Credit Score" v-model="personal_credit_score" placeholder="Enter Personal Credit Score">
                                        <div class="field-error">{{personaCreditScoreError}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <div class="example-label">
                                            <label class="control-label" for="last_review"> Last Credit Review: </label>
                                            <i class="fa fa-info-circle" aria-hidden="true" ></i>
                                        </div>
                                        <date-picker placeholder="MM/DD/YYYY" id="last_review" name="last_credit_review" :config="options" v-model="last_credit_review"></date-picker>
                                        <div class="field-error">{{lastCreditReviewError}}</div>
                                    </div>
                                </div>
                            </div>
                            <hr class="light-hr"/>
                            <div class="list-sections">
                                <h5 class="section-title">Fill By Customer  </h5>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label" for="name"> Company Name: </label>
                                        <input type="text" class="form-control" disabled="disabled" iname="name" v-model="company">
                                        <div class="field-error">{{companyError}}</div>
                                        <div class="field-error">{{companyEmailError}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="email"> Email: </label>
                                        <input type="email" class="form-control" disabled="disabled" name="email" v-model="email" >
                                        <div class="field-error">{{emailerror}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="name"> Owner Name: </label>
                                        <input type="text" class="form-control" name="owner" v-model="owner">
                                        <div class="field-error">{{ownerError}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="name"> DBA (if any): </label>
                                        <input type="text" class="form-control" v-model="dba" name="text">
                                        <div class="field-error">{{dbaError}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="fax-number"> Fax Number: </label>
                                        <input type="text" class="form-control" v-cleave="{delimiter: '-',blocks: [3, 3, 4]}" v-model="fax" id="fax" placeholder="999-999-9999" name="fax">
                                        <!-- <input-mask id="fax" :alwaysShowMask="true" name="fax" v-model="fax" mask="999-999-9999" class="form-control" type="tel"></input-mask> -->
                                        <div class="field-error">{{faxError}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label " for="name"> State: </label>
                                        <v-select v-model="state" name="parent_id"
                                                    label="text" :filterable="false" :options="stateArr"
                                                    @search="onSearchState"
                                                    placeholder="Select State" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search States ...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{stateError}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label " for="name"> City: </label>
                                        <a href="javascript:void(0)" v-on:click="addNewCity()" class="pull-right color-blue link-text"> <i class="fp-add font-weight-bold" style="font-size:10px;"></i> Add City</a>
                                        <v-select v-model="city" name="parent_id"
                                                    label="text" :filterable="false" :options="cityArr"
                                                    @search="onSearchCity"
                                                    placeholder="Select City" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search City ...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{city_error_msg}}</div>
                                        <div class="field-error">{{cityError}}</div>
                                        <template v-if = "canAddCity">
                                          <div class="citycreate wo-vendorinv-form" >
                                              <city-add-form :id="'addCity'" v-on:populateCityId="popCityName($event)" class="citycreate wo-vendorinv-panel"></city-add-form>
                                          </div>
                                        </template>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="address"> Address: </label>
                                        <textarea rows="1" v-model="address" name="address" class="form-control"></textarea>
                                        <div class="field-error">{{addressError}}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label" for="name"> Zip: </label>
                                        <input type="text" class="form-control" v-model="zip" name="zip" @keypress="isIntegerCheck($event)">
                                        <div class="field-error">{{zipError}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="name"> Select Partnership: </label>
                                        <v-select v-model="partnership" name="parent_id"
                                                    label="text" :filterable="false" :options="partnershipArr"
                                                    placeholder="Select" class="custom-ci-auto-search">
                                        </v-select>
                                    </div>
                                    <div class="col form-group" v-if="partnership.text == 'Corporation - State Incorporated' || partnership.text == 'LLC'">
                                        <label class="control-label" for="name"> </label>
                                        <v-select v-model="corpText" name="parent_id"
                                                    label="text" :filterable="false" :options="stateArr"
                                                    @search="onSearchState"
                                                    placeholder="Select Corporation State" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search States ...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{corpTextError}}</div>
                                    </div>
                                    <!-- <div class="col form-group" v-if="partnership.text == 'Other'">
                                        <label class="control-label" for="name"> </label>
                                        <input type="text" class="form-control" id="email" v-model="otherText" name="other">
                                        <div class="field-error">{{otherError}}</div>
                                    </div> -->
                                    <div class="col form-group" v-if="partnership.text == 'Corporation - State Incorporated'  || partnership.text == 'LLC'">
                                        <label class="control-label require" for="name"> Federal Tax ID#: </label>
                                        <input type="text" class="form-control" v-model="federalTxId" name="text">
                                        <div class="field-error">{{fedTxError}}</div>
                                    </div>
                                    <div class="col form-group" v-if="partnership.text == 'Sole Proprietorship'">
                                        <label class="control-label require" for="name"> Name of Principal:  </label>
                                        <input type="text" class="form-control" v-model="socialName" name="text">
                                        <div class='field-error'>{{socialNameError}}</div>
                                    </div>
                                    <p>&nbsp;</p>
                                     <div class="col form-group col-md-6" v-if="partnership.text == 'Partnership'">
                                        <label class="control-label require" for="name"> Name of Principal:  </label>
                                        <template v-for="(pname,pkey) in socialNameArr">
                                            <div :key="pkey">
                                                <!-- <label class="control-label" for="name" v-if="pkey != 0"> &nbsp; </label> -->
                                                <input type="text" class="form-control col-md-6 pull-left adjust-margin" v-model="pname.socialName" name="text">
                                                <div class="col-md-6 form-group pull-right adjust-margin">
                                                    <template>
                                                        <a href="" class="fp-remove" v-on:click.prevent="addName('remove',pkey)"></a>
                                                    </template>
                                                    <label>&nbsp;&nbsp;</label>
                                                    <template>
                                                        <a href="" class="fp-plus" v-if="pkey + 1 === socialNameArr.length " v-on:click.prevent="addName('add','')"></a>
                                                    </template>
                                                </div>
                                                <!-- <button class="bt btn-primary col-md-1" v-on:click.prevent="addName('remove',pkey)"> X </button> -->
                                                <div class='field-error'>{{pname.socialNameError}}</div>
                                            </div>
                                        </template>
                                        <!-- <button class="bt btn-primary" v-on:click.prevent="addName('add','')">Add</button> -->
                                    </div>
                                    <div class="col form-group" v-if="partnership.text == 'Sole Proprietorship' || partnership.text == 'Partnership'">
                                        <label class="control-label require" for="name" style="margin-top: -17px;line-height: 11px;">Social Security Number of Principal (if other than corporation):  </label>
                                        <input type="text" class="form-control" v-model="socialSecnum" name="text">
                                        <div class='field-error'>{{socSecError}}</div>
                                    </div>
                                </div>
                                <div class="field-error" >{{partnershipError}}</div>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label" for="name"> Current Velocity Vehicle Group customer:  </label>
                                        <div class="custome-radiobtn">
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="current_cust"> Yes
                                                    <input type="radio" checked="checked" name="current" v-model="currentCustomer" :value="'yes'" id="current_cust">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="current_cust1"> No
                                                    <input type="radio" checked="checked" name="current" v-model="currentCustomer" :value="'no'" id="current_cust1">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="field-error">{{currentError}}</div>
                                        </div>
                                    </div>
                                    <div class="col form-group" v-if="currentCustomer == 'yes'">
                                        <label class="control-label require" for="name">  Which Company: </label>
                                        <v-select v-model="whichCom" label="text" class="custom-vselect" placeholder="Which Company" :options="companyArr"></v-select>
                                        <div class="field-error">{{whichComError}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="name"> Year Business Started: </label>
                                        <input type="text" class="form-control" v-model="businessStartYear" name="text">
                                        <div class="field-error">{{businessError}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="name">  D-U-N-S #: </label>
                                        <input type="text" v-model="dunsNum" class="form-control" name="text">
                                        <div class="field-error">{{dunsError}}</div>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-4 row-cols-1">

                                    <div class="col form-group">
                                        <label class="control-label" for="name"> Billing Contact: </label>
                                        <input type="text" class="form-control" v-model="billingContact" name="text">
                                        <div class="field-error">{{billingError}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label " for="name"> Email: </label>
                                        <input type="email" class="form-control" v-model="billingEmail" name="text">
                                        <div class="field-error">{{billingemailerror}}</div>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label" for="name"> Resale?: </label>
                                        <div class="custome-radiobtn">
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="resale"> Yes
                                                    <input type="radio" checked="checked" name="resale" v-model="resale" :value="'yes'" id="resale">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="resale1"> No
                                                    <input type="radio" checked="checked" name="resale" v-model="resale" :value="'no'" id="resale1">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-2 row-cols-1">
                                    <div class="col form-group" v-if="resale == 'yes'">
                                        <label class="control-label">Resale Document : </label>
                                        <vue-dropzone
                                            id="vendorEstimateDropzone"
                                            :options="dropzoneOptions"
                                            :destroyDropzone=false
                                            ref="dropzone"
                                            :headers="dropzoneOptions.headers"
                                            @vdropzone-complete="afterComplete"
                                            @vdropzone-success="storeDocument"
                                            @vdropzone-removed-file="removedSelectedFile"
                                            >
                                        </vue-dropzone>
                                        <div class="field-error">{{docError}}</div>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-2 row-cols-1">
                                    <div class="col form-group" v-if="resale == 'yes'">
                                        <template  v-if="dropZonePreviewFiles.length > 0">
                                            <label class="control-label" for="vendorEstimateDocs">Attachments:</label>
                                            <template  v-for="(uFile,fKey) in dropZonePreviewFiles">
                                                <div v-bind:key="'fileDiv'+fKey" class="attachment-list">
                                                    <i v-if="uFile.extension == 'pdf'" class="fp-pdf-icon"></i>
                                                    <i v-if="uFile.extension == 'doc' || uFile.extension == 'docs'" class="fp-text-document"></i>
                                                    <i v-if="uFile.extension == 'jpg' ||  uFile.extension == 'png' ||  uFile.extension == 'jpeg' " class="fp-image"></i>
                                                    <a title='View File' href="javascript:void(0)"  v-on:click="openDocument(uFile.url,uFile.extension)" v-bind:key="'fileName'+fKey" >
                                                        {{ uFile['display_name'] }}
                                                    </a>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                                    <button type="button"  v-bind:key="'cancelBtn'+fKey" v-on:click="removeServerFile(uFile['file_name'],fKey,'resaledoc');">
                                                        <i class="fp-close"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-2 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label" for="name"> Printed Name: </label>
                                        <input type="text" class="form-control" disabled='disabled' v-model="company" name="text">
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="name">Title: </label>
                                        <input type="text" class="form-control" v-model="title" name="text">
                                        <input type="hidden" id="ip" name="text">
                                        <div class="field-error">{{titleError}}</div>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-1 row-cols-1">
                                    <div class="col form-group">
                                        <div class="custom-checkbox">
                                            <label class="checkbox-custom">  By filling these credit details, I agree to receive invoices via email
                                                <input type="checkbox" name="invoice" v-model="invoiceViaMail">
                                                <span class="checkmark"></span>
                                                <div class="field-error">{{invoiceError}}</div>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-2 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label">SIGNATURE:</label>
                                        <div id="app">
                                            <VueSignaturePad class="form-signature" v-if="sign1 == ''"
                                                                height="200px"
                                                                ref="custsignaturePad"
                                                                style="border: 1px solid #bababa;margin-top:0;margin-bottom:14px; border-radius: 5px;"
                                            />
                                            <img v-if="sign1 != ''" :src="sign1" style="width:500px,height:200px;" alt="">
                                            <div v-if="sign1 == ''">
                                                <button type="submit" class="btn btn-primary" v-on:click.prevent="custsave" >
                                                    <i class="fp-save"> </i>  Done
                                                </button>
                                                <button type="submit" class="btn btn-secondary" v-on:click.prevent="custundo" >
                                                    <i class="fp-import"> </i> Undo
                                                </button>
                                            </div>
                                            <div v-else>
                                                <button class="btn btn-primary" v-on:click.prevent="sign1 = ''">Edit</button>
                                            </div>
                                            <div class="field-error">{{sign1Error}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="alert alert-warning hide col-sm-6" id="alertError">
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                    <strong id="errorMsg" class="error"></strong>
                                </div>
                            </div>
                            <div class="btn-groups text-right">
                                <button type="submit" id="CreateCustomerBtn" v-if="$route.params.flag == 'update' || customerUpdateflag==true" class="btn btn-primary" v-on:click.prevent="CreateCustomerCredit" >
                                    <i class="fp-reload"> </i>  Update
                                </button>
                                <button type="submit" id="CreateCustomerBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateCustomerCredit" >
                                    <i class="fp-save"> </i>  Save
                                </button>
                                <button type="submit" id="cancelCustomerBtn" class="btn btn-tertiary" v-on:click.prevent="BackCustomerList" >
                                    <i class="fp-close"> </i> Cancel
                                </button>
                            </div>
                        </form>
                    </section>
                </div>
            </div>
        </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
    import Vue from "vue";
    import EventBus from "./event-bus";


    import {commonMixins} from '../mixins/commonMixins';
    import VueSignaturePad from 'vue-signature-pad';
    Vue.use(VueSignaturePad);
    // import InputMask from 'vue-input-mask';
    // Vue.component('input-mask', InputMask);
    //Vue DropZone
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import CityCreate from '@/components/CityCreate.vue';
    Vue.component("city-add-form", CityCreate);

    export default {
        name: "CustomerCreate",
        metaInfo() {
            return {
                title: (this.$route.query.customerflag == 'update' || this.$route.query.flag == 'update')? "Update Customer Credit Information | " +process.env.COPYRIGHT_NAME : "Create Customer Credit Information | " +process.env.COPYRIGHT_NAME
            }
        },
        components: {
            vueDropzone: vue2Dropzone,

        },
        mixins:[commonMixins],
        data: () => ({
            canAddCity:false,
            city_error_msg:"",
            permissions: [],
            cantAccessPage: "",
            loading:false,
            sicCode: "",
            sicCodesArr: [],
            options: {
                format: 'MM/DD/YYYY',
                useCurrent: true,
                maxDate:new Date()
                // maxDate:Date.prototype.toLocaleString
            },
            credit_limit: "",
            credit_limit_error_msg: "",
            //credit_manager: "",
            creditManagerArr: [],
            creditManagererrors: "",
            isEdit: false,
            contact:"",
            phone:"",
            phoneable:"yes",
            rentable:"yes",
            account_opened:"",
            credit_recieved:"",
            mailable:"yes",
            emailable:"yes",
            //d_b_rating:"",
            //d_b_pay_idx:"",
            rent_for_phone:"yes",
            rent_for_mail:"yes",
            rent_for_email:"no",
            //credit_limit_bg:"",
            //dunning_level:"",
            discount_lost:"no",
            //restrictions:"",
            priority_code:"",
            //customer_type:"",
            customerTypeArr:[],
            one_time_cust:"no",
            reserve_to_sfx:"",
            last_code_key_use:"",
            //message_code:"",
            contacterrors:"",
            phoneerrors:"",
            company:"",
            fax:"",
            owner:"",
            email: '',
            address:"",
            city:"",
            state:"",
            zip:"",
            corporation:"",
            stateInco:"",
            partnership:"",
            corpText:"",
            soleProp:"",
            dba:"",
            businessType:"",
            businessStartYear:"",
            currentCustomer:"",
            whichCom:"",
            socialName:"",
            socialSecnum:"",
            dunsNum:"",
            federalTxId:"",
            po:"no",
            creditAmount:"",
            billingContact:"",
            billingEmail:"",
            invoiceViaMail:false,
            resale:"no",
            refCompany:"",
            refphone:"",
            refFax:"",
            refbusinessType:"",
            refbusinessYear:"",
            refAddress:"",
            refAccountNum:"",
            sign:"",
            printedName:"",
            title:"",
            date:"",
            texPayerName:"",
            txBusinessName:"",
            fedTxclassification:"",
            exemptPayeeCode:"",
            reportingCode:"",
            txAddress:"",
            txAdress1:"",
            tinSecurityNumber:"",
            tinEmpNumber:"",
            loggedinUserId:"",
            userRole:"",
            custEmail:"",
            files:[],
            lease:false,
            rental:false,
            parts:true,
            selectedFile:null,
            docError:"",
            emailerror:"",
            billingemailerror:"",
            socSecError:"",
            credit_error:"",
            ownerError : "",
            dbaError : "",
            faxError : "",
            addressError : "",
            partnershipError : "",
            cityError : "",
            stateError : "",
            zipError : "",
            businessError : "",
            businessTypeError : "",
            currentError : "",
            whichComError : "",
            dunsError : "",
            fedTxError : "",
            billingError : "",
            companyError:"",
            socialNameError:"",
            otherError:"",
            otherText:"",
            poError:"",
            corpTextError:"",
            applicationForError:"",
            // errors:[],
            stateArr:[],
            cityArr:[],
            businessArr:[],
            sign1:"",
            sign2:"",
            sign1Error:"",
            socNameError:"",
            ein:"",
            ipAddress:"",
            titleError:"",
            invoiceError:"",
            phoneerror:"",
            resaleDoc:"",
            resaleDocPath:"",
            resaleDocDisplayFileName:"",
            fullPath:"",
            filesArr:[],
            partnershipArr:[{value:'Corporation - State Incorporated',text:'Corporation - State Incorporated'},
                {value:'Partnership',text:'Partnership'},{value:'Sole Proprietorship',text:'Sole Proprietorship'},
                // {value:'Other',text:'Other'}
                {value:'LLC',text:'LLC'}
                ],
            existFilesArr:[],
            creditDetailId:0,
            customerflag:false,
            custmer_id_val:0,
            customerError:"",
            customerArr : [],
            creditId:0,
            customerUpdateflag:false,
            companyEmailError:"",
            ansonia_risk_store:"",
            //ansonia_dtp:"",
            //ansonia_high_balance:"",
            years_in_business:"",
            paynet_master_score:"",
            dnb_paydex_score:"",
            credit_grade:"",
            full_kin_score:"",
            last_credit_review:"",
            lastCreditReviewError:"",
            dnbPaydexError:"",
            ansoniaRiskScoreError:"",
            ansoniaDTPError:"",
            ansoniaHighBalanceError:"",
            paynetMasterError:"",
            yearsInBusinessError:"",
            creditGradeError:"",
            kinScoreError:"",
            fromCustomer:false,
            dot:"",
            doterror:"",
            resalefiles:[],
            dropzoneOptions: {
                url: process.env.ROOT_API +"/customer-credit-info/store-docs",
                method: 'POST',
                maxFilesize: 3.99, //MB
                maxFiles: 1,
                thumbnailWidth: 150, // px
                thumbnailHeight: 150,
                addRemoveLinks: true,
                acceptedFiles: ".jpg, .jpeg, .png, .doc, .pdf, .docx",
                headers: {
                    'Accept': 'application/json',
                    "Authorization": "Bearer "+localStorage.getItem("tkn"),
                    'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                    "Cache-Control": "no-cache"
                },
                dictRemoveFileConfirmation: "Are you sure? You can\'t revert your action",
                destroyDropzone:false,
            },
            dropZonePreviewFiles:[],
            verificationFiles:[],
            verificationDropzoneOptions:{
                url: process.env.ROOT_API +"/customer-credit-info/store-docs",
                method: 'POST',
                maxFilesize: 3.99, //MB
                maxFiles: 5,
                thumbnailWidth: 150, // px
                thumbnailHeight: 150,
                addRemoveLinks: true,
                acceptedFiles: ".jpg, .jpeg, .png, .doc, .pdf, .docx",
                headers: {
                    'Accept': 'application/json',
                    "Authorization": "Bearer "+localStorage.getItem("tkn"),
                    'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                    "Cache-Control": "no-cache"
                },
                dictRemoveFileConfirmation: "Are you sure?You can\'t revert your action",
                destroyDropzone:false,
            },
            verificationdropZonePreviewFiles:[],
            docErrorVerification:"",
            tax_exempt:false,
            socialNameArr:[{socNameError:'',socialName:'',}],
            personal_credit_score:"",
            personaCreditScoreError:"",
            pg_required:false,
            docRequired:""
        }),

        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'add_customer') {
                            self.cantAccessPage = true;
                        }
                    }
                }

            },

            //if state value update after then change the city value also update that in thie module.
            state: function(state) {

                var self = this;

                if(self.state == null){
                    self.city_id = "";
                    self.cityArr = [];
                }
            },
            custmer_id_val:function(customer)
            {
                var self = this;
               console.log(customer)
                self.company=customer.name;
                self.email=customer.email;
                self.dot=customer.dot;
            }

        },
        created: function() {

        },
        mounted: function() {
            var self = this;
            self.getPermissions();
            self.getSidCodes();
            self.getbusinessType();
//            self.Gettimezone(0);
            self.loadCustomerSearchData();
            self.getBusinessType();

            if(self.$route.query.customerflag == 'add'){
                self.customerflag=true;
            }else if(self.$route.query.customerflag == 'update'){


                self.customerUpdateflag=true;
                var path = window.location.pathname;
                var segments = path.split("/");
                self.creditInformation(segments[3])
                self.creditId=segments[3];

            } else{

                self.getUserDetails();
                var path = window.location.pathname;
                var segments = path.split("/");
                self.fromCustomer=true;
                if (segments[3]) {
//                    alert('here');
//                    self.loadCustomer();

                    if(self.$route.query.creditId!=0 && self.$route.query.creditId!=undefined && self.$route.params.creditId!="" )
                    {
//                        alert("in credit id ")

                        self.creditId=self.$route.query.creditId;
                        self.customerUpdateflag=true;
                        self.creditDetailId = self.creditId;

                        self.creditInformation(self.creditId)
                        self.customer_id=segments[3];
//                        alert(self.customer_id);
//                        alert(self.creditId)
                    }
                    self.customerCreditInformation(segments[3])
                    $('#email-hide').hide();
                    $('#phone-hide').hide();
                }
                self.fullPath = process.env.FOLDER_URL + "/";
                setTimeout(function(){
                    $(document).ready(function() {
                        $('form').submit(function(evt){
                            evt.preventDefault();// to stop form submitting
                        });
                    },200);
//                    if(self.$route.query.flag == 'update'){
//                        var url = window.location.pathname;
//                        url = url.replace('create','update');
//                        // alert(url);
//                        history.pushState({}, null, url);
//                    }


                    if (segments[2] == 'update') {
                        self.$route.query.flag = 'update';
                    }
                });
            }



        },
        methods: {
        popCityName(cid){
         console.log("check"+cid);
        // this.city_id =cid;
         this.city = {value: cid.id, text: cid.name};
        },
        //load files in drop zone
        loadFilesPreview:function() {
            var self = this;
            if ( self.dropZonePreviewFiles.length > 0 ) {

                for ( var i = 0;i<self.dropZonePreviewFiles.length;i++ ) {

                    var file = { size: self.dropZonePreviewFiles[i].size, name: self.dropZonePreviewFiles[i].file_name, type: self.dropZonePreviewFiles[i].file_type};
                    var url = self.dropZonePreviewFiles[i].url;
                    //get file path from url
//                    self.files.push(self.getFilePathFromUrl(self.dropZonePreviewFiles[i].url));
                    //self.$refs.dropzone.manuallyAddFile(file, url);
                }
            }
        },

        removedSelectedFile(file, xhr, error) {
            var self = this;

            var woveId = "";
            var fileName = JSON.parse(file.xhr.response).content;

            var fileArr = fileName.split("/");

            self.removeFileFromServer(fileArr[1],woveId,"temp",'resaledoc');

            for(var i = 0;i<self.files.length;i++){
                if ( self.files[i].includes(fileName)) {
                    self.files.splice(i,1);
                }
            }

            console.log(self.files);

        },

        verificationremovedSelectedFile(file, xhr, error) {
            var self = this;

            var woveId = "";
            var fileName = JSON.parse(file.xhr.response).content;

            var fileArr = fileName.split("/");

            self.removeFileFromServer(fileArr[1],woveId,"temp",'verificationDoc');

            for(var i = 0;i<self.verificationFiles.length;i++){
                if ( self.verificationFiles[i].includes(fileName)) {
                    self.verificationFiles.splice(i,1);
                }
            }

            console.log(self.verificationFiles);

        },

        getFilePathFromUrl (value) {

            var path = "";
            var src = value.split('/');
            var file_name = src[src.length - 1];
            var orgPath = src[src.length - 2];
            path = orgPath + "/" + file_name;
            return path;

        },

        removeServerFile(fileName,key,from='') {

            var self = this;
            var woveId = "";
            var path = window.location.pathname;
            var segments = path.split("/");
            if ( segments[3] != undefined ) {
                woveId = segments[3];
            }

            if (confirm('Are you sure that you want to remove file? ')) {

                self.removeFileFromServer(fileName,woveId,"server",from);
                    if(from=='resaledoc'){
                        self.dropZonePreviewFiles.splice(key,1);
                        //remove file from files array
                        for ( var i = 0;i<self.files.length;i++ ) {
                            if ( self.files[i].includes(fileName)) {
                                self.files.splice(i,1);
                            }
                        }
                    }else{
                         self.verificationdropZonePreviewFiles.splice(key,1);
                         //remove file from files array
                        for ( var i = 0;i<self.verificationFiles.length;i++ ) {
                            if ( self.verificationFiles[i].includes(fileName)) {
                                self.verificationFiles.splice(i,1);
                            }
                        }
                    }
            }

        },
        removeFileFromServer(file, woveId,flag,from=''){

            var self = this;

            $.ajax({
                url: process.env.ROOT_API + "/customer-credit-info/remove-doc",
                type: "POST",
                data: {
                    filePath : file,
                    id: woveId,
                    flag:flag,
                    from:from
                },
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {

                    self.loading = false;
                },
                error: function (jqXHR, exception) {

                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, true,'remove-credit-resale-document');
                }
            });

        },
        afterComplete(file,response){
            var self = this;
        },

        storeDocument(file,response){
            var self = this;
            var uploadResponse = response.content;
            //push doc path in files array
            self.files.push(uploadResponse);

        },
        verificationstoreDocument(file,response){
            var self = this;
            var uploadResponse = response.content;
            //push doc path in files array
            self.verificationFiles.push(uploadResponse);

        },

        undo() {
            this.$refs.signaturePad.undoSignature();
        },
        save() {
            const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
            console.log(isEmpty);
            console.log(data);
            this.sign2 = data;
        },
        custundo() {
            this.$refs.custsignaturePad.undoSignature();
        },
        custsave() {
            this.sign1Error = "";
            const { isEmpty, data } = this.$refs.custsignaturePad.saveSignature();
            console.log(isEmpty);
            console.log(data);
            if(!isEmpty){
                this.sign1 = data;
            }else{
                //if sign1 is empty or blank show validation message
                this.sign1Error = "Signature Required";
            }
        },
        customerCreditInformation(id) {

            var self = this;
            self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/customer-credit-info/" + id,
                    type: "GET",
                    headers: this.ajxHeaders,
                    data:{from:'create'},
                    crossDomain: true,
                    dataType: 'json',
                    success: function (data) {

                        self.loading = false;
                        if (data.code == 200) {

                            setTimeout(function(){
                                self.customer_id = data.content.customer_id;
                                self.contact = data.content.credit_contact;
                                //self.credit_manager = {value:data.content.creditManId , text:data.content.creditName};
                                self.phone = data.content.phone;
                                self.phoneable = data.content.phoneable;
                                self.rentable  = data.content.rentable;
                                self.account_opened = data.content.account_opened;
                                self.credit_recieved = data.content.credit_recieved;
                                self.mailable = data.content.mailable;
                                self.emailable = data.content.e_mailable;
                                //self.d_b_rating = data.content.d_b_rating;
                                //self.d_b_pay_idx = data.content.d_b_pay_idx;
                                self.rent_for_phone = data.content.rent_for_phone;
                                self.credit_limit = data.content.credit_limit;
                                self.rent_for_mail = data.content.rent_for_mail;
                                self.rent_for_email = data.content.rent_for_email;
                                //self.credit_limit_bg = data.content.credit_limit_bg;
                                //self.dunning_level = data.content.dunning_level;
                                self.discount_lost = data.content.discount_lost;
                                //self.restrictions = data.content.restrictions;
                                self.sicCode = {value:data.content.sicCode,text:data.content.sicName+' ('+data.content.sicCode+')'};
                                self.priority_code = data.content.priority_code;
                                //self.customer_type = {value:data.content.customer_type,text:self.titleCase(data.content.customer_type)};
                                self.one_time_cust = data.content.one_time_cust;
                                self.reserve_to_sfx = data.content.reserve_to_sfx;
                                self.last_code_key_use = data.content.last_key_code_use;
                                //self.message_code = data.content.message_code;
                                if (data.content.social_security_name.includes(',')){
                                    var nm = data.content.social_security_name;
                                    var nm = nm.split(',');
                                    if (nm != undefined && nm.length > 0){
                                        self.socialNameArr = [];
                                        for(var i=0; i < nm.length; i++){
                                            self.socialNameArr.push({
                                                socialName:nm[i],
                                                socNameError:''
                                            })
                                        }
                                    }
                                }else{
                                    // self.socialNameArr = [];
                                    // self.socialNameArr.push({
                                    //     socialName:data.content.social_security_name,
                                    //     socNameError:''
                                    // })
                                    // self.socialName = data.content.social_security_name;


                                    if (data.content.partnership == 'Partnership'){
                                        self.socialNameArr = [];
                                            self.socialNameArr.push({
                                                socialName:data.content.social_security_name,
                                                socNameError:''
                                            })
                                    }else{
                                        self.socialName = data.content.social_security_name;
                                    }
                                }
                                self.socialSecnum = data.content.social_security_number;
                                self.company = data.content.company_name;
                                self.fax = data.content.fax;
                                self.owner_name = data.content.owner_name;
                                self.email = data.content.email;
                                self.address = data.content.address;
                                self.city = {text:data.content.city,value:data.content.city};
                                self.state = {text:data.content.state,value:data.content.stateId};
                                self.zip = data.content.zip;
                                self.partnership = {value:data.content.partnership,text:data.content.partnership};
                                //if which_company value from backend is undefined
                                if(data.content.which_company != "undefined" && (data.content.which_company != null && data.content.which_company != "")){
                                    self.whichCom = {value:data.content.which_company,text:data.content.which_company};
                                }else{
                                    self.whichCom = null;
                                }
                                // self.partnership.text = data.content.partnership
                                self.corpText = {text:data.content.corporation,value:data.content.corporation};
                                self.otherText=data.content.other;

                                self.federalTxId = data.content.federal_tx_id;
                                // self.businessType = {text:data.content.sicCode+' - '+data.content.sicName,value:data.content.sicCode};
                                self.businessStartYear = data.content.business_year;
                                self.currentCustomer = data.content.current_customer;
                                self.owner = data.content.owner_name;
                                if(data.content.dba != null){
                                  self.dba = data.content.dba;
                                }

                                self.address = data.content.address;
                                if(data.content.duns != null){
                                  self.dunsNum = data.content.duns;
                                }
                                if(data.content.billing_contact != null){
                                  self.billingContact = data.content.billing_contact;
                                }
                                if(data.content.billing_email != null){
                                  self.billingEmail = data.content.billing_email;
                                }

                                self.invoiceViaMail = data.content.recive_invoice_via_email;
                                if(self.invoiceViaMail === "yes"){
                                    self.invoiceViaMail = true;
                                }
                                else{
                                    self.invoiceViaMail = false;
                                }
                                self.resale = data.content.resale;
                                if(data.content.resale_doc_path!=null) {
                                    if(data.content.resale_doc_path[0]) {
                                        self.resaleDoc = data.content.resale_doc_path[0].file_name;
                                        self.resaleDocPath = data.content.resale_doc_path[0].url;
                                        self.resaleDocDisplayFileName = data.content.resale_doc_path[0].display_name;
                                    }
                                }
                                self.sign1 = data.content.signature;
                                self.title = data.content.title;
                                self.ansonia_risk_store=data.content.ansonia_risk_store;
                                //self.ansonia_dtp=data.content.ansonia_dtp;
                                //self.ansonia_high_balance=data.content.ansonia_high_balance;
                                self.years_in_business=data.content.years_in_business;
                                self.dnb_paydex_score=data.content.dnb_paydex_score;
                                self.paynet_master_score=data.content.paynet_master_score;
                                self.credit_grade=data.content.credit_grade;
                                self.full_kin_score=data.content.full_kin_score;
                                self.last_credit_review=data.content.last_credit_review;
                                self.personal_credit_score = data.content.personal_credit_score;
                                self.dot=data.content.dot;
                                var applicationFor = data.application_for;
                                self.rental = false;
                                self.lease = false;
                                self.parts = false;
                                applicationFor.forEach(function(value){
                                    // alert(value);
                                    if(value == 'Rental'){
                                        self.rental = true;
                                    }
                                    if(value == 'Lease'){
                                        self.lease = true;
                                    }
                                    if(value == 'Parts and Service'){
                                        self.parts = true;
                                    }
                                });
                                self.existFilesArr = data.content.docs;
                            },500);
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false,
                            self.label = 'Add';
                        self.Registerbtn = "Register";
                        self.generateStatusCodeMessage(jqXHR,true,'get-customercreditinformation');
                    }
                });

            },
            creditInformation(id) {

                var self = this;
                self.loading = true;

                    $.ajax({
                        url: process.env.ROOT_API + "/credit-info/" + id,
                        type: "GET",
                        headers: this.ajxHeaders,
                        data:{from:'create'},
                        crossDomain: true,
                        dataType: 'json',
                        success: function (data) {

                            self.loading = false;
                            if (data.code == 200) {
                                console.log(data);
                                setTimeout(function(){
                                    self.customer_id = data.content.customer_id;
                                    self.contact = data.content.credit_contact;
                                    self.dot=data.content.dot;
                                    //self.credit_manager = {value:data.content.creditManId , text:data.content.creditName};
                                    self.phone = data.content.phone;
                                    self.phoneable = data.content.phoneable;
                                    self.rentable  = data.content.rentable;
                                    self.account_opened = data.content.account_opened;
                                    self.credit_recieved = data.content.credit_recieved;
                                    self.mailable = data.content.mailable;
                                    self.emailable = data.content.e_mailable;
                                    //self.d_b_rating = data.content.d_b_rating;
                                    //self.d_b_pay_idx = data.content.d_b_pay_idx;
                                    self.rent_for_phone = data.content.rent_for_phone;
                                    self.credit_limit = data.content.credit_limit;
                                    self.rent_for_mail = data.content.rent_for_mail;
                                    self.rent_for_email = data.content.rent_for_email;
                                    //self.credit_limit_bg = data.content.credit_limit_bg;
                                    //self.dunning_level = data.content.dunning_level;
                                    self.discount_lost = data.content.discount_lost;
                                    //self.restrictions = data.content.restrictions;
                                    self.sicCode = {value:data.content.sicCode,text:data.content.sicName+' ('+data.content.sicCode+')'};
                                    self.priority_code = data.content.priority_code;
                                    //self.customer_type = {value:data.content.customer_type,text:self.titleCase(data.content.customer_type)};
                                    self.one_time_cust = data.content.one_time_cust;
                                    self.reserve_to_sfx = data.content.reserve_to_sfx;
                                    self.last_code_key_use = data.content.last_key_code_use;
                                    //self.message_code = data.content.message_code;
                                    // self.socialName = data.content.social_security_name;
                                    if (data.content.social_security_name.includes(',')){
                                        var nm = data.content.social_security_name;
                                        var nm = nm.split(',');
                                        if (nm != undefined && nm.length > 0){
                                            self.socialNameArr = [];
                                            for(var i=0; i < nm.length; i++){
                                                self.socialNameArr.push({
                                                    socialName:nm[i],
                                                    socNameError:''
                                                })
                                            }
                                        }
                                    }else{
                                        // self.socialNameArr = [];
                                        if (data.content.partnership == 'Partnership'){
                                            self.socialNameArr = [];
                                                self.socialNameArr.push({
                                                    socialName:data.content.social_security_name,
                                                    socNameError:''
                                                })
                                        }else{
                                            self.socialName = data.content.social_security_name;
                                        }
                                    }
                                    self.socialSecnum = data.content.social_security_number;
                                    self.company = data.content.company_name;
                                    self.fax = data.content.fax;
                                    self.owner_name = data.content.owner_name;
                                    self.email = data.content.email;
                                    self.address = data.content.address;
                                    self.city = {text:data.content.city,value:data.content.city};
                                    self.state = {text:data.content.state,value:data.content.stateId};
                                    self.zip = data.content.zip;
                                    self.partnership = {value:data.content.partnership,text:data.content.partnership};
                                    //if which_company value from backend is undefined
                                    if(data.content.which_company != "undefined" && (data.content.which_company != null && data.content.which_company != "")){
                                        self.whichCom = {value:data.content.which_company,text:data.content.which_company};
                                    }else{
                                        self.whichCom = null;
                                    }
                                    // self.partnership.text = data.content.partnership
                                    self.corpText = {text:data.content.corporation,value:data.content.corporation};
                                    self.federalTxId = data.content.federal_tx_id;
                                    self.otherText=data.content.other;
                                    // self.businessType = {text:data.content.sicCode+' - '+data.content.sicName,value:data.content.sicCode};
                                    self.businessStartYear = data.content.business_year;
                                    self.currentCustomer = data.content.current_customer;
                                    self.owner = data.content.owner_name;
                                    if(data.content.dba != null){
                                      self.dba = data.content.dba;
                                    }
                                    self.address = data.content.address;
                                    if(data.content.duns != null){
                                      self.dunsNum = data.content.duns;
                                    }
                                    if(data.content.billing_contact != null){
                                      self.billingContact = data.content.billing_contact;
                                    }
                                    if(data.content.billing_email != null){
                                      self.billingEmail = data.content.billing_email;
                                    }
                                    self.invoiceViaMail = data.content.recive_invoice_via_email;
                                    console.log(self.invoiceViaMail)
                                    if(self.invoiceViaMail === "yes"){
                                        self.invoiceViaMail = true;
                                    }
                                    else{
                                        self.invoiceViaMail = false;
                                    }
                                    self.resale = data.content.resale;
                                    if(data.content.resale_doc_path != null) {
                                        self.dropZonePreviewFiles = data.content.resale_doc_path;
                                        // self.files=data.content.resale_doc_path;
                                    }
                                    if(data.content.docs != null) {
                                        self.verificationdropZonePreviewFiles = data.content.docs;
                                    }


                                    // self.resaleDoc = data.content.resale_doc_path;
                                    // self.resaleDoc = data.content.resale_doc_file_name;
                                    // self.resaleDocPath = data.content.resale_doc_url;
                                    // self.resaleDocDisplayFileName = data.content.resale_doc_display_file_name;
                                    self.sign1 = data.content.signature;
                                    self.title = data.content.title;
                                    self.existFilesArr = data.content.docs;
                                    self.ansonia_risk_store=data.content.ansonia_risk_store;
                                    //self.ansonia_dtp=data.content.ansonia_dtp;
                                    //self.ansonia_high_balance=data.content.ansonia_high_balance;
                                    self.years_in_business=data.content.years_in_business;
                                    self.dnb_paydex_score=data.content.dnb_paydex_score;
                                    self.paynet_master_score=data.content.paynet_master_score;
                                    self.credit_grade=data.content.credit_grade;
                                    self.full_kin_score=data.content.full_kin_score;
                                    self.personal_credit_score = data.content.personal_credit_score;
                                    self.last_credit_review=data.content.last_credit_review;
                                    var applicationFor = data.application_for;
                                    self.rental = false;
                                    self.lease = false;
                                    self.parts = false;
                                    applicationFor.forEach(function(value){
                                        // alert(value);
                                        if(value == 'Rental'){
                                            self.rental = true;
                                        }
                                        if(value == 'Lease'){
                                            self.lease = true;
                                        }
                                        if(value == 'Parts and Service'){
                                            self.parts = true;
                                        }
                                    });
                                    if (data.content.tax_exemption != undefined && data.content.tax_exemption != null) {
                                        self.tax_exempt = data.content.tax_exemption;
                                    }
                                    if (data.content.pg_required != 0) {
                                        self.pg_required = true;
                                        self.docRequired = "require";
                                    }

                                },500);
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false,
                                self.label = 'Add';
                            self.Registerbtn = "Register";
                            self.generateStatusCodeMessage(jqXHR,false,'get-creditinformation');
                        }
                    });

            },
            getSidCodes: function() {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/get_sic_codes",
                    type: "GET",
                    success: function(data) {
                        self.sicCodesArr = data.content;
                    },
                    error: function() {
                        //   alert("An error occurred while processing the request.");
                    }
                });
            },
            getbusinessType: function() {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/get_business_types",
                    type: "GET",
                    success: function(data) {
                        self.customerTypeArr = data.content;
                    },
                    error: function() {
                        //   alert("An error occurred while processing the request.");
                    }
                });
            },


            onSearchState(search, loading) {
                var self = this;
                if (search.length > 2) {

                    loading(true);
                    self.searchField(loading, search, 'state', '');
                }
            },
            onSearchTaxState(search, loading) {
                var self = this;
                if (search.length > 2) {

                    loading(true);
                    self.searchField(loading, search, 'state', '');
                }
            },
            onSearchCity(search, loading) {
                var self = this;
                if (search.length > 2) {

                    var stateId = self.state.value;
// alert(stateId);

                    if ( stateId == "" ) {
                        alert("please select state first");
                        return;
                    }

                    loading(true);
                    self.searchField(loading, search, 'city', '');
                }
            },

            BackCustomerList() {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                if(self.fromCustomer==true)
                {
                    if (segments[3]) {
//                        self.$router.push("/dealer/view/"+segments[3]);
                        self.$router.push({ name: 'CustomerView',params:{id:segments[3],viewTab:"creditDetail" }});

                    }
                }
                else if(self.customerflag==true || self.customerUpdateflag==true){
                    self.$router.push("/customer-credit-details/list");
                }  else{
                    self.$router.push({ name: 'CustomerView',params:{id:segments[3],viewTab:"creditDetail" }});

//                    self.$router.push("/dealer/view/"+segments[3]);
                }
            },
            loadCustomerSearchData() {

                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/customer/search",
                    type: "GET",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    dataType: 'json',
                    success: function (data) {

                        if (data.status == "success") {

                            // self.taxArr = data.TaxData;
                            // self.termArr = data.TermData;
                            // self.classArr = data.ClassData;
                            self.creditManagerArr = data.creditManagerData;

                        }

                    },
                    error: function (jqXHR, exception) {
                        self.Registerbtn = "Register";
                        self.generateStatusCodeMessage(jqXHR,true,'credit-search-customer')

                    }
                });
            },
            onFileChanged (event) {
                const file = event.target.files[0]
                console.log(file);
                var self = this;
                self.selectedFile = file;
                console.log(self.selectedFile);
            },
            CreateCustomerCredit(flag) {

                var self = this;
                var error = 0;
                var path = window.location.pathname;
                var segments = path.split("/");
                const fields = new FormData();
                self.companyError = "";
                self.credit_error = "";
                self.emailerror = '';
                self.phoneerror = "";
                self.billingemailerror = '';
                self.credit_error = "";
                self.socSecError = "";
                self.ownerError = "";
                self.dbaError = "";
                self.faxError = "";
                self.addressError = "";
                self.partnershipError = "";
                self.cityError = "";
                self.stateError = "";
                self.zipError = "";
                self.businessError= "";
                self.businessTypeError = "";
                self.currentError = "";
                self.whichComError = "";
                self.dunsError = "";
                self.fedTxError = "";
                self.billingError = "";
                self.applicationForError = "";
                self.poError = "";
                self.socialNameError="";
                // self.errors = [];
                self.corpTextError = "";
                self.einError = "";
                self.titleError = "";
                self.sign1Error = "";
                self.docError = "";
                self.invoiceError = "";
                self.customerError = "";
                self.doterror = "";
                self.docErrorVerification = "";
                if (self.pg_required){
                  if((self.verificationFiles.length <= 0) && (self.verificationdropZonePreviewFiles.length <= 0)){
                    self.docErrorVerification = "Verification document required";
                    self.docError = ""
                    error = 1;
                  }
                }
                if(self.corpText == null){
                    self.corpText = "";
                }
                if(self.whichCom == null){
                    self.whichCom = "";
                }
                if(self.partnership == null){

                    self.partnership = '';
                }
                if(self.city == null){
                    self.city = '';
                }
                if(self.state == null){
                    self.state = '';
                }

                if(self.userRole == 'customer'){
                    log_flag = 'customer';
                }
                var customer_id = 0;
                //get customer id

                if ( self.userRole == "customer" && self.customerflag==false) {
                    customer_id = self.loggedinUserId;
                }
                else if(self.customerflag==true){
                    if (self.custmer_id_val == 0 || !self.custmer_id_val) {
                        self.customerError = "Customer Required";
                        error = 1;
                    }
                }else {
                    customer_id = localStorage.getItem('customer_id');
                }

                if (!self.phone || self.phone == null || self.phone == "") {
                    self.phoneerror = "Phone Number Required.";
                    error = 1;
                }
                 if (!self.dot || self.dot == null || self.dot == "") {
                    self.doterror = "Dot Number Required.";
                    error = 1;
                }

                var phoneRE = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

                if(self.phone && !self.phone.match(phoneRE)){
                    self.phoneerror = "Phone Number is not in proper format please update";
                    error = 1;
                }
                if(self.zip && (self.zip.length > 5 || self.zip.length < 5) ){
                  self.zipError = "Zip Must Consist of 5 Digits";
                  error = true;
                }

                if(self.currentCustomer == 'yes'){
                    if (!self.whichCom.text) {
                        self.whichComError = "Company Name Required";
                        error = 1;
                    }
                }

                if (self.billingEmail && !self.validEmail(self.billingEmail)) {
                    self.billingemailerror = '';
                    self.billingemailerror = "Email Must Be In Proper Email Format";
                    error = 1;
                }


                if(self.partnership.text != 'Other'){
                    self.otherText = "";
                }
                if(self.partnership.text == 'Other' && self.otherText == ''){
                    self.otherError = "Field Required";
                    error = 1;
                }


                if(self.partnership.text != 'Corporation - State Incorporated'){
                    if(self.corpText.text){
                        self.corpText.text = "";
                    }
                    self.corpText = "";
                    self.federalTxId = "";
                }
                if(self.partnership.text == 'Corporation - State Incorporated' ){
                    if (!self.federalTxId) {
                        self.fedTxError = "Federal Tax Id Number Required";
                        error = 1;
                    }

                }


                if(self.partnership.text == 'Corporation - State Incorporated' && !self.corpText.text){
                    self.corpTextError = "Corporation State Required";
                    error = 1;
                }

/*
                if(!self.invoiceViaMail){
                    self.invoiceError = "Please check for receive invoices via email";
                    error = 1;
                }
*/

                if(self.partnership.text == 'Sole Proprietorship'){
                    if(!self.socialSecnum){
                        self.socSecError = "Social Security Number Required";
                        error = 1;
                    }
                    if(!self.socialName){
                        self.socialNameError = "Name Required";
                        error = 1;
                    }
                }else{
                    self.socialName="";
                    if(self.partnership.text != 'Partnership'){
                        self.socialSecnum="";
                    }
                }
                if(self.partnership.text == 'Partnership'){
                    if(!self.socialSecnum){
                        self.socSecError = "Social Security Number Required";
                        error = 1;
                    }
                    // if(!self.socialName){
                    //     self.socialNameError = "Name Required";
                    //     error = 1;
                    // }
                    if (self.socialNameArr != null && self.socialNameArr.length > 0){
                        for(var i = 0; i < self.socialNameArr.length;i++){
                            if (self.socialNameArr[i].socialName == null || self.socialNameArr[i].socialName == ''){
                                self.socialNameArr[i].socialNameError = 'Social Name Required';
                                error = 1;
                            }
                        }
                    }
                }

                if(!self.po || self.po == ''){
                    self.poError = "Please Select PO Required Option?";
                    error = 1;
                }
                 if(self.resale == 'yes'){

                    if((!self.files || self.files==null || self.files.length <= 0) && (!self.dropZonePreviewFiles || self.dropZonePreviewFiles==null || self.dropZonePreviewFiles.length<= 0 )){
                        self.docError = "Resale Card Required";
                        error = 1;
                    }else{

                        if((!self.files || self.files==null || self.files.length <= 0) && (self.dropZonePreviewFiles && self.dropZonePreviewFiles!=null && self.dropZonePreviewFiles.length>1) ){

                            self.docError = "Maximun only one file are allows.";
                            error = 1;
                        }else if((self.files && self.files!=null && self.files.length > 0) && (self.dropZonePreviewFiles && self.dropZonePreviewFiles!=null && self.dropZonePreviewFiles.length>=1) ){
                            self.docError = "Maximun only one file are allows.";
                            error = 1;
                        }
                    }
                 }

                   if((!self.verificationFiles || self.verificationFiles==null || self.verificationFiles.length <= 0) && (self.verificationdropZonePreviewFiles && self.verificationdropZonePreviewFiles!=null && self.verificationdropZonePreviewFiles.length>5) ){

                            self.docErrorVerification = "Maximun only five file are allowed.";
                            error = 1;
                        }else if((self.verificationFiles && self.verificationFiles!=null && self.verificationFiles.length > 0) && (self.verificationdropZonePreviewFiles && self.verificationdropZonePreviewFiles!=null && self.verificationdropZonePreviewFiles.length>=1) ){
                             var total=self.verificationFiles.length + self.verificationdropZonePreviewFiles.length;
                             if(total > 5){
                                self.docErrorVerification = "Maximun only five file are allowed.";
                                error = 1;

                             }
                        }


                if(self.fax && self.fax != "___-___-____" && !self.fax.match(phoneRE)){
                    self.faxError = "Fax No must be in proper format";
                    error = 1;
                }
                if(error == 1){
                    self.errorValidationFocus();
                    return;
                }
                // const formData = new FormData();
                // fields.append('customer_id', customer_id);
                fields.append('company', self.company);
                fields.append('ein', self.ein);
                fields.append('phone', self.phone);
                fields.append('email', self.email);
                if(self.fax && self.fax == "___-___-____"){
                    fields.append('fax','');
                }else if (self.fax != "___-___-____") {
                    fields.append('fax', self.fax);
                }else{
                    fields.append('fax','');
                }
                fields.append('owner', self.owner);
                fields.append('address', self.address);

                if(self.city.text != '' && self.city.text != undefined ){
                    fields.append('city', self.city.text);
                }else{

                    fields.append('city', '');
                }
                if(self.state.text != '' && self.state.text != undefined ){
                    fields.append('state', self.state.text);
                }else{

                    fields.append('state', '');
                }


                fields.append('zip', self.zip);
                fields.append('dba', self.dba);
                // fields.append('businessType', self.businessType.value);
                fields.append('businessYear', self.businessStartYear);
                fields.append('currentCustomer', self.currentCustomer);
                //if currentCustomer No selected then which com.text is ""
                // alert(self.currentCustomer);
                if(self.currentCustomer == "no"){
                    if(self.whichCom.text){

                        self.whichCom.text = "";
                    }else{

                        self.whichCom = "";
                    }

                }

                if(self.whichCom.text != '' && self.whichCom.text != undefined ){
                    fields.append('whichCom', self.whichCom.text);
                }else{
                    fields.append('whichCom', '');
                }

                fields.append('socialSecnum', self.socialSecnum);
                fields.append('socialName', self.socialName);
                fields.append('dunsNum', self.dunsNum);
                fields.append('federalTxId', self.federalTxId);
                fields.append('po', self.po);
                fields.append('billingContact', self.billingContact);
                fields.append('billingEmail', self.billingEmail);
                if(self.invoiceViaMail === true){
                    self.invoiceViaMail = 'yes';
                }else{
                    self.invoiceViaMail = 'no';
                }
                fields.append('invoiceViaMail', self.invoiceViaMail);
                fields.append('resale', self.resale);

                if(self.partnership == null){
                    self.partnership = '';
                }
                if(!self.partnership.value){
                    fields.append('partnership',"");
                }else{
                    fields.append('partnership', self.partnership.value);
                }
                fields.append('otherText', self.otherText);
                if(self.corpText.text){
                    fields.append('corpText', self.corpText.text);
                }else{
                    fields.append('corpText', self.corpText);
                }
                fields.append('lease', self.lease);
                fields.append('rental', self.rental);
                fields.append('parts', self.parts);
                if(self.files.length > 0 ){
                    fields.append("myFile", JSON.stringify(self.files));
                }else{
                    fields.append( "myFile", null);
                }
                // fields.append('myFile', self.selectedFile);
                fields.append('sign1', self.sign1);
                fields.append('sign2', self.sign2);
                fields.append('ip', $("#ip").val());
                fields.append('title', self.title);
                fields.append('dot', self.dot);
                if(self.ansonia_risk_store==null)
                {
                    fields.append('ansonia_risk_store', "");
                }else{
                    fields.append('ansonia_risk_store', self.ansonia_risk_store);
                }
                // if(self.ansonia_dtp==null)
                // {
                //     fields.append('ansonia_dtp', "");
                // }else{
                //     fields.append('ansonia_dtp', self.ansonia_dtp);
                // }
                // if(self.ansonia_high_balance==null)
                // {
                //     fields.append('ansonia_high_balance', "");
                // }else{
                //     fields.append('ansonia_high_balance', self.ansonia_high_balance);
                // }
                if(self.years_in_business==null)
                {
                    fields.append('years_in_business', "");
                }else{
                    fields.append('years_in_business', self.years_in_business);
                }
                if(self.dnb_paydex_score==null)
                {
                    fields.append('dnb_paydex_score', "");
                }else{
                    fields.append('dnb_paydex_score', self.dnb_paydex_score);
                }
                if(self.paynet_master_score==null)
                {
                    fields.append('paynet_master_score', "");
                }else{
                    fields.append('paynet_master_score', self.paynet_master_score);
                }
                if(self.credit_grade==null)
                {
                    fields.append('credit_grade', "");
                }else{
                    fields.append('credit_grade', self.credit_grade);
                }
                if(self.full_kin_score==null)
                {
                    fields.append('full_kin_score', "");
                }else{
                    fields.append('full_kin_score', self.full_kin_score);
                }
                if(self.personal_credit_score==null)
                {
                    fields.append('personal_credit_score', "");
                }else{
                    fields.append('personal_credit_score', self.personal_credit_score);
                }
                if(self.last_credit_review==null)
                {
                    fields.append('last_credit_review', "");
                }else{
                    fields.append('last_credit_review', self.last_credit_review);
                }

                fields.append('creditId', self.creditId);

                if(self.verificationFiles.length > 0 ){
                    fields.append("files", JSON.stringify(self.verificationFiles));
                }else{
                    fields.append( "files", null);
                }
                fields.append("tax_exempt_value",1);
                if (self.tax_exempt) {
                    fields.append("tax_exemption",1);
                }else{
                    fields.append("tax_exemption",0);
                }
                fields.append('name_arr', JSON.stringify(self.socialNameArr));
                // for (var i = 0; i < self.filesArr.length; i++) {
                //     let file = this.filesArr[i];
                //     fields.append("files[]", file);
                // }
                if (error == 0) {
                    self.loading = true;
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    if (segments[3])
                    {
                        $("#CreateCustomerBtn").val("Updating ...");
                        $("#CreateCustomerBtn").prop("disabled", true);
                        $("#cancelCustomerBtn").prop("disabled",true);
                    } else {

                        $("#CreateCustomerBtn").val("Saving ...");
                        $("#CreateCustomerBtn").prop("disabled", true);
                        $("#createAndContinueCustomerBtn").prop("disabled", true);
                        $("#cancelCustomerBtn").prop("disabled",true);

                    }

                    fields.append('params',JSON.stringify($("#CustomerForm").serializeArray()));

                    if(self.customerflag==true && self.custmer_id_val!=0)
                    {

                        fields.append("customer_id",self.custmer_id_val.value);
                    }else if(self.customerUpdateflag == true)
                    {
                        if(self.fromCustomer == true)
                        {
                            fields.append("customer_id",segments[3]);
                        }else{
                            fields.append("customer_id",self.customer_id);
                        }

                    }
                    else{
                        fields.append("customer_id",segments[3]);

                    }


                    // if (self.credit_manager == null || !self.credit_manager.value) {
                    //     fields.append("credit_manager","" );
                    // } else {
                    //     fields.append( "credit_manager", self.credit_manager.value );
                    // }
                    // if (self.customer_type == null || !self.customer_type.value) {
                    //     fields.append("customer_type", "" );
                    // } else {
                    //     fields.append("customer_type", self.customer_type.value );
                    // }
                    if (self.sicCode == null || !self.sicCode.value) {
                        fields.append( "sic_code", "");
                    } else {
                        fields.append( "sic_code",self.sicCode.value );
                    }

                    $.ajax({
                        url: process.env.ROOT_API + "/customer-credit/create",
                        type: "POST",
                        data: fields,
                        headers: this.ajxHeaders,
                        crossDomain: true,
                        processData: false,
                        contentType: false,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;
                            if (segments[3])
                            {
                                $("#CreateCustomerBtn").val("Update");
                                $("#CreateCustomerBtn").prop("disabled", false);
                                $("#cancelCustomerBtn").prop("disabled",false);
                            } else {

                                $("#CreateCustomerBtn").val("Save");
                                $("#CreateCustomerBtn").prop("disabled", false);
                                $("#createAndContinueCustomerBtn").prop("disabled", false);
                                $("#cancelCustomerBtn").prop("disabled",false);
                            }
                            // return;
                            if (data.status == "success") {
                                if(self.fromCustomer==true)
                                {
                                    if (segments[3]) {
                                        self.$router.push({ name: 'CustomerView',params:{id:segments[3],viewTab:"creditDetail" }})
                                    }
                                }
                                else if(self.customerflag==true || self.customerUpdateflag==true )
                                {
                                    self.$router.push("/customer-credit-details/list");
                                }else{
                                    if (segments[3]) {
                                        self.$router.push({ name: 'CustomerView',params:{id:segments[3],viewTab:"creditDetail" }})

                                    }
                                }


                            } else if(data.status == "exist") {
                                self.companyEmailError = "This Company and Email id is Already Registered.";

                            }else
                            {
                                if (data.content.length > 0) {
                                    var err = "";
                                    for (var i = 0; i < data.content.length; i++) {
                                        err += data.content[i] + "<br>";
                                    }
                                    $("#errorMsg").html(err);
                                    $(".alert-warning").toggleClass("show");
                                    setTimeout(function () {
                                        $(".alert-warning").removeClass("show");
                                        $(".alert-warning").addClass("hide");
                                    }, 10000);
                                }
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            if (segments[3])
                            {
                                $("#CreateCustomerBtn").val("Update");
                                $("#CreateCustomerBtn").prop("disabled", false);
                                $("#cancelCustomerBtn").prop("disabled",false);
                            } else {

                                $("#CreateCustomerBtn").val("Save");
                                $("#CreateCustomerBtn").prop("disabled", false);
                                $("#createAndContinueCustomerBtn").prop("disabled", false);
                                $("#cancelCustomerBtn").prop("disabled",false);
                            }

                            self.generateStatusCodeMessage(jqXHR,false,'credit-data-store')

                        }
                    });
                }

            },

            validEmail: function(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },

            formatString(data) {
                var self = this;
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },

            titleCase(str) {
                if (str == null){
                    return;
                } else{
                    var value = str.toString()
                    return value.charAt(0).toUpperCase() + value.slice(1)
                }
            },
            getBusinessType:function(){

                var self = this;

                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/business_types",
                    type: "get",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    success: function (data) {
                        self.loading = false;

                        console.log(data.content.email);
                        if (data.status == "success") {
                            self.businessArr = data.content;
                        } else if (data.status == "error") {

                        }

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;

                        self.generateStatusCodeMessage(jqXHR,true,'credit-businesstype')

                    }
                });
            },
            getUserDetails:function(){
                var self = this;
                var cust_id = "";
                var flag = "";
                var path = window.location.pathname;
                var segments = path.split("/");

                cust_id = segments[3];


                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/customer/details",
                    type: "get",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    data: {id:cust_id,username:''},
                    success: function (data) {
                        self.loading = false;
                        self.Registeruserbtn = "UPDATE";
                        console.log(data.content.email);
                        if (data.status == "success") {
                            self.contactData = data.content;
                            console.log(self.contactData);
                            self.company = self.contactData.name;

                            // self.dot = self.contactData.dot;

                            if(self.contactData.email != '') {
                                self.email = self.contactData.email;
                            }else{
                                self.email = '';
                            }

                        } else if (data.status == "error") {

                        }

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.Registeruserbtn = "ADD";
                        self.generateStatusCodeMessage(jqXHR,true,'credit-userdetail')
                    }
                });
            },
            handleFilesUpload: function(event) {
                /* Get the uploaded files from the input.*/

                var self = this;
                self.filesArr = [];
                self.fileerroor_msg = "";

                let uploadedFiles = "";
                self.uploadBtn= "Uploading...";
                uploadedFiles = self.$refs.files.files;
                for (var i = 0; i < uploadedFiles.length; i++) {

                    this.filesArr.push(uploadedFiles[i]);

                }
                console.log(this.filesArr);
                this.$refs.files.value = '';
                self.uploadBtn= "Upload";
            },
            deleteVerificationDoc: function(id,key, type) {
                var self = this;

                if (confirm('Are you sure that you want to remove this file? ')) {
                    self.submitBtn = false;
                    console.log( self.$refs.files);
                    this.filesArr.splice(key,1)
                    self.$refs.files.value = '';
                }
                return;
                /*
                      check file already uploaded on server or not
                  */
            },
            downloadDoc(doc_path){
                var self = this;
//                alert()
                // self.Invoicefile = self.fullPath+doc_path;
                self.Invoicefile = doc_path;
                var save = document.createElement('a');
                save.href = self.Invoicefile;
                save.download = self.Invoicefile;
                save.target = '_blank';
                document.body.appendChild(save);
                save.click();
                document.body.removeChild(save);
            },
            addName:function(flag,ind){
                var self = this;

                if (flag == 'add'){
                    self.socialNameArr.push({
                        socialName:'',
                        socialNameError:'',
                    })
                }else{
                    self.socialNameArr.splice(ind,1);
                }
            },
            deleteCreditVerificationFile: function(key,file){

                var self = this;

                if (confirm('Are you sure that you want to remove this file? ')) {

                    if(self.creditId != '' && self.creditId != undefined){

                            self.loading = true;

                            $.ajax({
                                url: process.env.ROOT_API + "/remove_credit_verification_file",
                                type: "POST",
                                crossDomain: true,
                                dataType: "json",
                                headers: this.ajxHeaders,
                                data: {
                                    credit_id:self.creditId,
                                    doc_path:file
                                },
                                success: function(data) {
                                    self.loading = false;
                                    //console.log(data.content[0]["id"]);
                                    if (data.status == "success") {

                                        self.creditInformation(self.creditId);
                                        // $("#myModal").modal("hide");
//                                        self.filesArr.splice(key,1);
                                        self.$refs.files.value = '';
                                    }
                                },
                                error: function(jqXHR, exception) {
                                    self.loading = false;
                                    self.files.splice(key,1);
                                    self.generateStatusCodeMessage(jqXHR,true,'credit-deleteverificationfile')

                                }
                            });

                        } else{

                            self.filesArr.splice(key,1);
                            self.$refs.files.value = '';

                        }
                }

            },
            onSearch(search, loading)
            {
                if (search.length > 1) {
                    loading(true);
                    this.checkCustomer(loading, search, this);
                }
            },
            checkCustomer: function (loading, search) {
                var self = this;
                // self.loading = true;
                //self.CheckBtn = "Checking ...";
                // $("#registerForm").trigger("reset");
                $.ajax({
                    url: process.env.ROOT_API + "/search",
                    type: "POST",
                    crossDomain: true,
                    headers: this.ajxHeaders,
                    data: {
                        search: search,
                        flag:"customer"
                    },
                    dataType: "json",
                    success: function (data) {
                        //console.log(data.content[0]["id"]);
                        //self.CheckBtn = 'Check';
                        if (data.status == "success") {
                            self.loading = false;
                            loading(false);
                            self.customerArr = data.content;


                        }
                    },

                    error: function (jqXHR, exception) {
                        self.loading = false;
                        //self.CheckBtn = 'Check';
                        self.generateStatusCodeMessage(jqXHR,true,'credit-checkcustomer')
                    }
                });

            },
            /* removeSpace(str) {
                var target = this;
                return target.split(search).join(replacement);
            } */
            taxEmeptSelect(event) {
                var self = this;
                self.tax_exempt = event.target.checked;
            },
            pgRequireSelect(event) {
                var self = this;
                self.pg_required = event.target.checked;
                if(self.pg_required){
                  self.docRequired = "require";
                }else{
                  self.docRequired = "";
                }
            },

        }
    };

</script>
<style scoped>
.adjust-margin{
    margin-top : 10px !important;
}
</style>




// WEBPACK FOOTER //
// src/components/CustomerCreditInformation.vue